
import { computed, defineComponent, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import ViewActions from "@/views/pages/application/view/tabs/ViewActions.vue";
import Documents from "@/views/pages/application/view/tabs/Document.vue";
import NoteSection from "@/components/sections/NoteSection.vue";

export default defineComponent({
  name: "kt-vertical-wizard",
  components: {
    ViewActions,
    Documents,
    NoteSection,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const modalNoteType = "Recruitment";

    const currentRecruitment = computed(() => {
      return store.getters.currentRecruitment;
    });

    const currentIrbReviewer = computed(() => {
      return store.getters.currentIrbReviewer;
    });

    const currentIrbReviewNote = computed(() => {
      return store.getters.currentReviewNoteEdit;
    });

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const currentApplication = computed(() => {
      return store.getters.currentApplication !== null
        ? store.getters.currentApplication.data
        : {};
    });

    const IsIrbMember = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbmember") !== -1) {
        return "Yes";
      }
      return "No";
    });

    const IsIrbChair = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbchair") !== -1) {
        return "Yes";
      }
      return "No";
    });

    onMounted(() => {
      store.dispatch(Actions.GET_IRB_APPLICATION_RECRUITMENT, route.params.id);
      setCurrentPageBreadcrumbs("Vertical", ["Pages", "Wizards"]);
    });

    watch(
      () => route.params.id,
      async () => {
        await store.dispatch(
          Actions.GET_IRB_APPLICATION_RECRUITMENT,
          route.params.id
        );
      }
    );

    return {
      currentRecruitment,
      currentIrbReviewNote,
      currentIrbReviewer,
      IsIrbMember,
      currentApplication,
      IsIrbChair,
      modalNoteType,
    };
  },
});
